import * as React from 'react';

import { AccessAlarm, Announcement } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { SFCampaignPromotionItemViewModel } from '@api/index';

import { BannerLabel, IconWrapper, CampainBannerContainer } from './styled';

const Icons = {
  default: Announcement,
  alarm: AccessAlarm,
};

export interface IAppProps
  extends Pick<SFCampaignPromotionItemViewModel, 'title'> {
  icon: keyof typeof Icons;
}

const CampainBanner = ({ title, icon }: IAppProps) => {
  const Icon = Icons[icon];

  return (
    <CampainBannerContainer>
      <IconWrapper>
        <CustomIcon icon={Icon} fontSize={45} fill='white' />
      </IconWrapper>

      <BannerLabel>{title ?? ''}</BannerLabel>
    </CampainBannerContainer>
  );
};

export default CampainBanner;
